


















import Vue from 'vue'
import MainContainer from '@/layouts/main-container.vue'
import DefaultLayout from '@/layouts/default-layout.vue'

export default Vue.extend({
  name: 'CardCanvas',

  components: {
    DefaultLayout,
    MainContainer,
  },

  props: {
    /* See main container */
    size: {
      type: String,
      default: 'medium',
    },
    hideBackButton: {
      type: Boolean,
      default: false,
    },
    unstickHeader: {
      type: Boolean,
      default: false,
    },
  },
})
